export default function Logo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <span className="w-11 h-11 rounded-full bg-white border border-line shadow-soft flex items-center justify-center overflow-hidden shrink-0">
        <img src="/logo.png" alt="Logo Dentalchivasso" className="w-[86%] h-[86%] object-contain" draggable={false} />
      </span>
      <span className="leading-none">
        <span className={`block font-display text-[1.35rem] font-semibold tracking-tight ${light ? "text-ivory" : "text-ink"}`}>
          Dental<em className="not-italic text-teal">chivasso</em>
        </span>
        <span className={`block mt-1 text-[0.62rem] font-semibold italic tracking-[0.14em] ${light ? "text-teal-mist" : "text-teal"}`}>
          il dentista amico
        </span>
      </span>
    </span>
  );
}